import { useEffect } from 'react'
import { useAuthContext } from '@/features/auth/hooks/use-auth-context'
import { useOrganizationMemberships } from '@/hooks/use-organization-memberships'
import { useIsSuperAdmin } from '@/hooks/use-permissions'
import {
  ORGANIZATION_IN_URL_POLICY,
  type OrganizationInUrlPolicy,
  setOrganizationInUrlPolicy,
} from '@/lib/tab-organization'

export const MULTI_ORGANIZATION_MEMBERSHIP_COUNT = 2

export function useOrganizationInUrlPolicy(): OrganizationInUrlPolicy {
  const isSuperAdmin = useIsSuperAdmin()
  const { user, isLoading: isLoadingUser } = useAuthContext()
  const { memberships, isSuccess, isError } = useOrganizationMemberships({
    enabled: !isLoadingUser && user !== null && !isSuperAdmin,
  })

  if (isSuperAdmin || isError) return ORGANIZATION_IN_URL_POLICY.CARRY
  if (!isSuccess) return ORGANIZATION_IN_URL_POLICY.UNKNOWN
  return memberships.length >= MULTI_ORGANIZATION_MEMBERSHIP_COUNT
    ? ORGANIZATION_IN_URL_POLICY.CARRY
    : ORGANIZATION_IN_URL_POLICY.OMIT
}

export function usePublishOrganizationInUrlPolicy(): void {
  const policy = useOrganizationInUrlPolicy()
  useEffect(() => {
    setOrganizationInUrlPolicy(policy)
  }, [policy])
}
